import { useStoreState } from "../../hooks/ep";

export function useFirebaseState() {
  return useStoreState((s) => s.firebase.firebaseState);
}
